// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e07c13c6","455":"e161e47b"}[chunkId] + ".chunk.js";
};